import { Component, OnInit,Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AuthentificationService } from "projects/hp-api/src/lib/services/authentification-service.service";
import { AlertService } from 'projects/hp-api/src/lib/services/alert.service'
import { first } from 'rxjs/operators';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { SignConfirmComponent } from '../dialogs/sign-confirm/sign-confirm.component';
import { InfosPrixComponent } from '../dialogs/infos-prix/infos-prix';
import { UserService } from "projects/hp-api/src/lib/services/user.service";
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted = false;
  hide = false;
  returnUrl: string;
 
  constructor(public fb: FormBuilder,
    private authentificationService : AuthentificationService,
    private userService: UserService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router,   
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<LoginComponent>, @Inject(MAT_DIALOG_DATA) data)  {
    
 // redirect to home if already logged in
 if (this.authentificationService.currentUserValue) { 
  

}


   }

  ngOnInit() {
 
    this.loginForm = this.fb.group({
      username: ['', [Validators.required,Validators.email]],
      password: ['', Validators.required]
  });



  // get return url from route parameters or default to '/'
  //this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  /*
  Open dialog Particulier or Prof
  */
 openDialog() {
  const dialogRef = this.dialog.open(SignConfirmComponent,{
    data: { name: "demande" }
  });
  
  
  
  dialogRef.afterClosed().subscribe(result => {
    
  });

}

 /* Reactive form */
 reactiveForm() {
}

/*
get formControl for fields
*/
get f() { return this.loginForm.controls; }


getValidator(){
 return this.loginForm.invalid;
}

onSubmit() {
  this.submitted = true;

  // stop here if form is invalid
  if (this.loginForm.invalid) {
      return;
  }
 

  //this.loading = true;
  this.authentificationService.login(this.f.username.value, this.f.password.value)
      .pipe(first())
      .subscribe(
          data => {
          this.dialogRef.close();
           const dialogRefpdf = this.dialog.open(InfosPrixComponent,{panelClass: 'full-width-dialog-pdf',
              data: { name: "pdf" }
            });
            dialogRefpdf.afterClosed().subscribe(result => {
              
            });

              
          },
          error => {
              this.alertService.error(error);
             // this.loading = false;
          });
}





}
